import Repository from "./Repository";

export default {
  getBlogs(page, limit) {
    return Repository.get(`blog?page=${page}&limit=${limit}&isAdmin=true`);
  },
  blogSearchByTitle(title, page) {
    return Repository.get(`blog/searchByTitle/${title}?page=${page}&limit=10`);
  },
  singleBlog(id) {
    return Repository.get(`blog/${id}`);
  },
  createBlog() {
    return Repository.get(`blog/empty`);
  },

  addBlog(payload) {
    const formData = new FormData();
    formData.append("title", payload.title);
    formData.append("description", payload.description);
    formData.append("category", payload.category);
    formData.append("file", payload.file);
    payload?.subCategory?.forEach((str, index) => {
      formData.append(`subCategory[${index}]`, str);
    });
    formData.append("metaTitle", payload.metaTitle);
    formData.append("metaDescription", payload.metaDescription);
    formData.append("altText", payload.altText);
    formData.append("blogUrl", payload.blogUrl);
    formData.append("summaryPdf", payload.summaryPdf ? payload.summaryPdf : "");
    formData.append("isFeatured", payload.isFeatured);
    if (payload?.scheduleTime) {
      formData.append("scheduleTime", payload.scheduleTime);
    }
    return Repository.post(`blog`, formData);
  },
  updateBlog(id, payload) {
    const formData = new FormData();
    formData.append("title", payload.title);
    formData.append("description", payload.description);
    formData.append("category", payload.category);
    formData.append("file", payload.file);
    payload?.subCategory?.forEach((str, index) => {
      formData.append(`subCategory[${index}]`, str);
    });
    formData.append("metaTitle", payload.metaTitle);
    formData.append("metaDescription", payload.metaDescription);
    formData.append("altText", payload.altText);
    formData.append("blogUrl", payload.blogUrl);
    formData.append("isFeatured", payload.isFeatured);
    formData.append("summaryPdf", payload.summaryPdf ? payload.summaryPdf : "");
    if (payload?.scheduleTime) {
      formData.append("scheduleTime", payload.scheduleTime);
    }
    if (payload?.updatedAt) {
      formData.append("updatedAt", payload.updatedAt);
    }
    return Repository.put(`blog/${id}`, formData);
  },
  deleteBlog(id) {
    return Repository.delete(`blog/${id}`);
  },
  getAllDownloads(page, limit) {
    return Repository.get(`blog/downloads?page=${page}&limit=${limit}`);
  },
};
